import React, { Fragment } from "react";
import { Outlet } from "react-router";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import ActivityReview from "./ActivityReview";
import BeyoLine from "./BeyoLine";
import Investment from "./Investment";
import ProfileGreeting from "./ProfileGreeting";
import SocialShared from "./SocialShared";
import Transaction from "./Transaction";
import UpgradeHistory from "./UpgradeHistory";
import ValueChart from "./ValueChart";
import YearlyView from "./YearlyView";
import OrderStatistics from "./OrderStatistics";
import CollectionCharts from "./CollectionCharts";
import OrderPipeline from "./OrderPipeline";

const Default = () => {
    return (
        <Fragment>
            <Breadcrumbs mainTitle="Dashboard" parent="Dashboard" />
            <Container fluid={true} className="px-4">
                <OrderStatistics />
                <CollectionCharts />
                <OrderPipeline />
                <Row>
                    {/* <ProfileGreeting />
                    <ActivityReview />
                    <BeyoLine />
                    <Investment />
                    <SocialShared />
                    <Transaction />
                    <UpgradeHistory />
                    <ValueChart />
                    <YearlyView /> */}
                </Row>
            </Container>
        </Fragment>
    );
};

export default Default;